var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pr-0 pl-0",attrs:{"fluid":""}},[_c('b-navbar',{attrs:{"id":"navbar","toggleable":"md","type":"dark","variant":"dark"}},[_c('b-container',[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_c('b-navbar-brand',{attrs:{"to":{ name: 'home', params: {} }}},[_vm._v("hiko.kiwi")]),_c('b-collapse',{attrs:{"id":"nav_collapse","is-nav":""}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":{ name: 'home', params: {} },"exact":""}},[_vm._v("Menu")]),_c('b-nav-item',{attrs:{"to":{
              name: 'map',
              params: {
                type: 'charging'
              }
            },"active":_vm.mapNavActive}},[_vm._v("Map")]),_c('b-nav-item',{attrs:{"to":{
              name: 'nearest'
            }}},[_vm._v("Nearest")]),_c('b-nav-item',{attrs:{"to":{
              name: 'list'
            }}},[_vm._v("List")]),_c('b-nav-item',{attrs:{"to":{
              name: 'recent'
            }}},[_vm._v("Recent")]),_c('b-nav-item',{attrs:{"to":{
              name: 'info'
            }}},[_vm._v("Help")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }